import React from 'react';
import BaseCard from './baseCard';
import Events from './events';
import OrganisationTiles from './organisationTiles';
import FeatureCard from './featureCard';
import FormWidget from './formWidget';
import GridWidget from "./grid";
import IceLink from "./IceLink";
import ImageWidget from "./imageWidget";
import InfoBox from "./infoBox";
import LocationsLazyLoad from "./locationsLazyLoad";
import SupportedBy from './supportedBy';
import MemberCard from "./memberCard";
import PageBlock from "./PageBlock";
import Posts from './posts';
import Section from "./section";
import Spacer from "../common/spacer";

const widgets: IWidget[] = [
    {
        shortcode: "base-card",
        component: BaseCard,
        attributes: {
            images: "images",
        }
    },
    {
        shortcode: "events",
        component: Events,
        attributes: {
            events: "upcomingEvents",
        },
    },
    {
        shortcode: "feature-card",
        component: FeatureCard,
        attributes: {
            images: "images",
        }
    },
    {
        shortcode: "form",
        component: FormWidget,
        attributes: {
            forms: "forms",
            submissionsUrl: "submissionsUrl",
            returnUrl: "returnUrl",
        },
        unwrapComponent: true,
    },
    {
        shortcode: "grid",
        component: GridWidget,
        unwrapComponent: true,
    },
    {
        shortcode: "image",
        component: ImageWidget,
        attributes: {
            images: "images",
        }
    },
    {
        shortcode: "infobox",
        component: InfoBox,
        attributes: {
            images: "images",
            pages: "pages",
        }
    },
    {
        shortcode: "link",
        component: IceLink,
        attributes: {
            pages: "pages",
        }
    },
    {
        shortcode: "locations",
        component: LocationsLazyLoad,
        attributes: {
            locations: "locations"
        }
    },
    {
        shortcode: "member-card",
        component: MemberCard,
        attributes: {
            images: "images",
            people: "people",
        },
        unwrapComponent: true,
    },
    {
        shortcode: "organisation-tiles",
        component: OrganisationTiles,
        attributes: {
            organisations: "locations",
        }
    },
    {
        shortcode: "block",
        component: PageBlock,
        attributes: {
            page: "page",
        },
        unwrapComponent: true,
    },
    {
        shortcode: "posts",
        component: Posts,
        attributes: {
            posts: "recentPosts",
        },
    },
    {
        shortcode: "section",
        component: Section,
        attributes: {
            images: "images",
        },
        unwrapComponent: true,
    },
    {
        shortcode: "spacer",
        component: Spacer,
    },
    {
        shortcode: "supported-by",
        component: SupportedBy,
        attributes: {
            supporters: "supporters",
        },
    },
]

export interface IWidget {
    shortcode: string;
    component: React.ComponentType;
    attributes?: IAttributes;
    unwrapComponent?: boolean;
}

interface IAttributes {
    [key: string]: any;
}

const getWidgetComponents = () => {
    var components = {};
    widgets.map(w => {
        components[w.component.NAME] = w.component;
    });

    return components;
}

export { widgets, getWidgetComponents };